// 入校申请
<template>
  <el-container>
    <el-header class="visitor_header">
      <div>
        <p>一网通办校外用户办事入口</p>
      </div>
    </el-header>
    <el-main class="visitor_main" style="min-height: 600px">
      <el-row>
          <el-button type="primary" class="buttenStyle" @click="applyForEntry">发起入校申请</el-button>
      </el-row>
      <div v-if="total > 0">
        <div class="mainTitle">历史申请</div>
        <el-collapse v-model="activeName" accordion>
          <div
              v-for="(fkform, index) in fkyyxxList"
              :key="fkform.lsh"
              class="listStyle"
          >
            <el-collapse-item :name="index">
              <template slot="title">
                <el-col :span="6">
                  {{ fkform.name }}
                </el-col>
                <el-col :span="12" class="formNYR">
                  {{ fkform.jxsjFrom }}-{{ fkform.jxsjTo }}
                </el-col>
                <el-col :span="4">
                  <div
                      class="listStyleState"
                      :style="getTitleStyle(fkform.state)"
                  >
                    {{ isTG(fkform.state) }}
                  </div>
                </el-col>
              </template>
              <el-row v-if="fkform.state == -1">
                <el-col :span="6" class="formTitleStyle">不同意原因：</el-col>
                <el-col :span="18" class="formBodyStyle">{{
                    fkform.btyyy
                  }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="6" class="formTitleStyle">访问对象：</el-col>
                <el-col :span="18" class="formBodyStyle"
                >{{ fkform.fwdxxm }}({{ fkform.fwdxgh }})</el-col
                >
              </el-row>
              <el-row>
                <el-col :span="6" class="formTitleStyle">入校人员：</el-col>
                <el-col :span="18" class="formBodyStyle">{{
                    fkform.rxry
                  }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="6" class="formTitleStyle">入校事由：</el-col>
                <el-col :span="18" class="formBodyStyle">{{
                    fkform.rxsy
                  }}</el-col>
              </el-row>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
      <div v-else>
        <el-row>
          <p>暂无申请数据</p>
        </el-row>
      </div>
    </el-main>
    <el-footer>
      <div class="footerButtonRow">
        <el-row>
          <el-button type="" @click="loginClick" class="inputwidth">
            重新登录
          </el-button>
        </el-row>
        <el-row>
          <div class="userid">
            <i class="el-icon-user"> : {{ userid }}</i>
          </div>
        </el-row>
      </div>
      <div class="Verify_footer">Copyright@齐鲁工业大学（山东省科学院）</div>
    </el-footer>
  </el-container>
</template>
import axios from 'axios'
<script>
export default {
  data() {
    return {
      applys: [],
      userid: "",
      activeName: "1",
      fkyyxxList: [],
      total: 0,
      fontweight: "bold",
      textalign: "right",
    };
  },
  created() {
    this.getUser();
    this.getApplyList();
  },
  methods: {
    async getApplyList() {
      const { data: res } = await this.$http.get("jxsq", {
        params: { tel: this.userid },
      });
      this.fkyyxxList = res.data;
      this.total = res.numbers;
    },

    async getUser() {
      var user = sessionStorage.getItem("user");
      if (!user) return;
      var tel = JSON.parse(user);
      this.userid = tel;
    },
    applyForEntry() {
      const token = sessionStorage.getItem("login_token");
      console.log(token);
      if (!token) {
        this.$message.error("请先登录");
        this.$router.push("/login");
        return;
      }
      // 直接跳转后端302接口
      window.location.href = "/visitorspring/getRedirectUrl?token=" + token;


    },
    isTG(state) {
      if (state == "1") {
        return "已通过";
      } else if (state == "0") {
        return "审批中";
      } else {
        return "未通过";
      }
    },

    getTitleStyle(state) {
      var textcolor = "#909399";
      if (state == -1) {
        textcolor = "#DC143C";
      }
      if (state > 0) {
        textcolor = "#004387";
      }
      return {
        fontWeight: this.fontweight,
        textAlign: this.textalign,
        color: textcolor,
      };
    },

    loginClick() {
      sessionStorage.clear();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.div_pagination {
  text-align: center;
}
.inputwidth {
  width: 100%;
}
.userid {
  padding: 5px 0px 5px 0px;
  text-align: center;
}
.Verify_footer {
  background-color: #004387;
  color: #ffffff;
  text-align: center;
  font-size: 75%;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 20px;
  margin: 0px;
}
.el-footer {
  height: 6rem !important ;
  padding: 0 0.125rem 0 0;
}
.footerButtonRow {
  padding: 10px;
}
.buttenStyle {
  border-radius: 4px;
  height: 40px;
  width: 100%;
  font-size: 100%;
}
.el-header {
  background-color: #004387;
  text-align: center;
  color: #ffffff;
  font-size: 120%;
}
.listStyleState {
  float: right;
  height: 100%;
}
.mainTitle {
  margin: 0.5rem 0 0.375rem;
  color: #004387;
  text-align: left;
  font-weight: 600;
}
.formTitleStyle {
  text-align: left;
  color: #787b81;
}
.formBodyStyle {
  text-align: left;
  color: #909399;
}
.formNYR {
  font-size: 75%;
}
</style>